import { Link } from "react-router-dom";
import { COLLECTION_LINK, MEDIA_LINK, termList } from "../../constant";
import { appName } from "../../config";
import { useTranslation } from "react-i18next";

const TermAndInfo = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`footer.${key}`);
  const communityList = window?.communityInfo || [];

  return (
    <>
      <section className="grid grid-cols-1 md:grid-cols-3 items-center text-white  gap-[40px]">
        <div className="grid grid-cols-2 gap-[10px] md:text-start text-center">
          {termList.map((item, index) => {
            return (
              <Link
                key={item.label}
                to={`/terms${item.link}`}
                className="text-base text-white hover:text-main-color"
              >
                {i18n(item.label)}
              </Link>
            );
          })}
        </div>
        <div className="flex flex-col items-center">
          <p>{i18n("focusUs")}</p>
          <div className="grid grid-cols-5 gap-[10px]">
            {MEDIA_LINK.map((item) => {
              return (
                <Link
                  key={item.link}
                  className="text-white hover:text-main-color"
                  to={item.link}
                >
                  {item.icon}
                </Link>
              );
            })}
          </div>
        </div>
        <div className="flex flex-col items-center my-8">
          <p>{i18n("Collections")}</p>
          <div className="grid grid-cols-2 gap-[10px] items-start">
            {COLLECTION_LINK.map((item) => {
              return (
                <a
                  key={item.link}
                  className="text-white hover:text-main-color"
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="flex items-center justify-start">
                    {item.icon}
                    {i18n(item.title)}
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default TermAndInfo;
